import { TFunction } from 'i18next';

import { Typography } from '@cfa/react-components';

const NoAnswerAndErrorText: React.FC<{ error: boolean; t: TFunction }> = ({
  error,
  t,
}) => (
  <>
    <Typography className="text-grayscale-gray7! font-medium!">
      {t(
        error
          ? 'AISearchPOC.thereWasAProblem'
          : 'AISearchPOC.noAnswerAvailable',
      )}
    </Typography>
    <Typography>
      {t(
        error
          ? 'AISearchPOC.thereWasAProblemDescription'
          : 'AISearchPOC.noAnswerAvailableDescription',
      )}
    </Typography>
  </>
);

export default NoAnswerAndErrorText;
